<template>
  <router-view />
</template>

<script>
export default {
  name: 'PatientMain'
}
</script>

<style lang="scss" scoped></style>
